window.InsiderProgram = window.InsiderProgram || {};
InsiderProgram.options = {
    app_domain: 'https://app.686.com'
};
InsiderProgram.initCache = function () {
    InsiderProgram.cache = {
        $reg_form: $('#InsiderProgramRegisterForm'),
        $login_form: $('#CustomerLoginForm'),
        $reg_trigger: $('#InsiderProgramTriggerRegister'),
        $login_trigger: $('.InsiderProgramTriggerLogin'),
        $verify_passcode: $('#InsiderProgramPasscodeInput'),
        $verify_trigger: $('#InsiderProgramTriggerRegister'),
        $verify_response: $('#InsiderProgramVerifyResponse')
    };
};

InsiderProgram.init = function () {
    console.log('Insider Program JS Initialization');
    InsiderProgram.initCache();
    InsiderProgram.initCustomerActions();

};

InsiderProgram.initCustomerActions = function () {
    /*SIGNUP*/
    if (typeof INSIDER_PROGRAM_SIGNUP !== 'undefined') {
        if (timber.getHash() == '#InsiderProgram-AccountExists' && Cookies.get('riders_account_exists_error')) {
            $('#InsiderProgramAccountExists').show();
            Cookies.remove('riders_account_exists_error');
        }
        if (insider_program_status === 1 && timber.getHash() != '#InsiderProgramNewCode') {
            window.location = "/pages/insider-program";
            return false;
        } else {
            if (timber.getHash() == '#InsiderProgram-Verify' || timber.getHash() == '#InsiderProgram-OnboardCheck' || timber.getHash() == '#InsiderProgramNewCode') {

                if (timber.getHash() == '#InsiderProgram-OnboardCheck' && insider_program_status < 1) {
                    console.log('--[Insider Program]-- Onboard Trigger for customer: ' + INSIDER_PROGRAM_CUSTOMER_ID);
                    $.post(InsiderProgram.options.app_domain + '/api/EU/customer/' + INSIDER_PROGRAM_CUSTOMER_ID + '/onboarding', {})
                        .done(function (data) {
                            if (data.status == 200) {
                                console.log(data);
                            }
                        });
                }
                console.log('--[Insider Program]-- Step 2 Trigger');
                InsiderProgram.initCache();
                $('#InsiderProgram-Step2').show();
                setTimeout(function () {
                    console.log('test');
                    InsiderProgram.cache.$verify_trigger.on('click', function (e) {
                        e.preventDefault();
                        var $passcode = InsiderProgram.cache.$verify_passcode.val();
                        var $customer_id = INSIDER_PROGRAM_CUSTOMER_ID;
                        var $input = {
                            passcode: $passcode,
                            customer_id: $customer_id
                        };
                        InsiderProgram.cache.$verify_trigger.html('Verifying... <i class="fad fa-spinner-third fa-spin"></i>').off();
                        $.post(InsiderProgram.options.app_domain + '/api/EU/activate', $input)
                            .done(function (data) {
                                if (data.status == 200) {
                                    console.log('--[Insider Program]-- ACTIVATE CALL:');
                                    console.log(data);
                                    window.location = "/pages/insider-program";

                                   /* InsiderProgram.cache.$verify_passcode.removeClass('error').hide();
                                    InsiderProgram.cache.$verify_response.removeClass('error');
                                    InsiderProgram.cache.$verify_response.show().find('.message').text(data.message);
                                    InsiderProgram.cache.$verify_response.find('.fa-exclamation').removeClass('fa-exclamation').addClass('fa-check');
                                    InsiderProgram.cache.$verify_trigger.fadeOut().text('SHOP DISCOUNTS').attr('href', '/').fadeIn();*/
                                } else {
                                    InsiderProgram.cache.$verify_passcode.addClass('error');
                                    InsiderProgram.cache.$verify_response.show().addClass('error').find('.message').text(data.message);
                                    InsiderProgram.cache.$verify_response.find('.fa-check').removeClass('fa-check').addClass('fa-exclamation');
                                }
                            });

                        console.log($passcode, $customer_id);
                    });

                }, 666);

            } else {
                console.log("ELSE");
                if (insider_program_status === 1) {
                    window.location = "/pages/insider-program";
                } else if (insider_program_status === 0 && INSIDER_PROGRAM_CUSTOMER_ID) {
                    console.log('-> RIDERS UNION ONBOARD <-');
                    window.location = "/pages/insider-program-login#InsiderProgram-OnboardCheck";
                    window.location.reload();
                    $('#InsiderProgram-Step2').show();
                } else if (insider_program_status === 2 && INSIDER_PROGRAM_CUSTOMER_ID) {
                    window.location = "/pages/insider-program-login#InsiderProgram-Verify";
                    $('#InsiderProgram-Step2').show();
                    window.location.reload();
                } else if (insider_program_status === -1) {
                    InsiderProgram.cache.$reg_trigger.on('click', function (e) {
                        e.preventDefault();
                        InsiderProgram.cache.$login_form.slideUp(686);
                        setTimeout(function () {
                            InsiderProgram.cache.$reg_form.slideDown(686);
                        }, 686);
                        $('.btn--insider-program').removeClass('active');
                        $(this).addClass('active');
                    });
                    InsiderProgram.cache.$login_trigger.on('click', function (e) {
                        e.preventDefault();

                        InsiderProgram.cache.$reg_form.slideUp(686);
                        setTimeout(function () {
                            InsiderProgram.cache.$login_form.slideDown(686);
                        }, 686);
                        $('.btn--insider-program').removeClass('active');
                        $(this).addClass('active');
                    });
                }
            }
        }
    }
    /*Accounts*/
    if (typeof RIDERS_UNION_ACCOUNT !== 'undefined') {
        console.log('RIDERS_UNION_ACCOUNT');


    }
};

$(InsiderProgram.init);